import React, { lazy } from 'react';
const PurchaseItemListing = lazy(() =>
  import(
    'containers/GeneralSettingModule/PurchaseItemModule/PurchaseItemListing'
  ).then(module => ({
    default: module.PurchaseItemListing,
  })),
);

const purchaseItemRoutes = [
  {
    props: {
      exact: true,
      path: '/:mode/general-settings/purchase-item',
    },
    component: <PurchaseItemListing />,
  },
];

export default purchaseItemRoutes;
